import { translationStatistics_en_part1 } from "./translationStatistics.en.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationStatistics_en_part2 } from "./translationStatistics.en.part2";
import { translationStatistics_en_part3 } from "./translationStatistics.en.part3";
import { translationStatistics_en_part4 } from "./translationStatistics.en.part4";
import { translationStatistics_en_part5 } from "./translationStatistics.en.part5";

export const translationStatistics_en = defineTranslationTree({
  aiClickRate: "Product and link clickthrough",
  aiClickRateTooltip:
    "Conversations with a click divided by conversations shown an AI link or product action. Each conversation counts once; shown means rendered in the chat, even below the visible area.",
  hyperlinkClickRate: "Hyperlinks",
  productClickRate: "Product cards",
  clickRateCounts: "{clicked} of {eligible} conversations",
  clickRateViewBreakdown: "View hyperlink and product click rates",
  clickRateBreakdownHint:
    "Each type uses its own shown conversations as the denominator. A conversation can click both types, so these rates do not add up. Product clicks include opening a product, add-to-cart and wishlist actions; follow-up prompts are excluded.",
  clickRateTrackingNote:
    "Based on recorded exposures since click tracking launched. Historical chats without recorded exposures are excluded.",
  ...translationStatistics_en_part1,
  ...translationStatistics_en_part2,
  ...translationStatistics_en_part3,
  ...translationStatistics_en_part4,
  ...translationStatistics_en_part5,
});
